var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLogin)?_c('div',[_c('a',[_c('AvatarDropdown',{attrs:{"current-user":_vm.currentUser}})],1)]):_c('div',{staticClass:"lens-user-login-btn",on:{"click":function($event){return _vm.userLogin()}}},[_c('a',{staticClass:"user-btn"},[_c('span',{staticClass:"lens-icon"},[_c('a-icon',{attrs:{"type":"login"}}),_vm._v("登录 ")],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }